// src/store/rack/RackMinerStore.ts
import { GetUserById_RequestTypes } from '@mobx/api/users';
import apiService, { createStore, RequestControl, withLoading } from '@mobx/services/http';
import { action, makeObservable, observable } from 'mobx';
import { IItemStore, IItemStoreBase, IMainLocationsStore, IRackStore } from './interfaces';
import createRackMinerStore from './miner';
import { IColoredUser3, ISomeItem, isRackItem3, RACK_SECTION_TYPE3 } from './types';

export const createItemStore_ = (
  item: ISomeItem, 
  index: number, 
  mainStore: IMainLocationsStore,
  rackStore: IRackStore,
) => (rc: RequestControl): IItemStore => {
  const getUserById = apiService.createRequest(GetUserById_RequestTypes);

  const self: IItemStoreBase = {
    isLoading: false,
    isMerging: false,
    isLocked: true,
    item,
    itemIndex: index,
    rackStore,

    setMerging(v) {
      self.isMerging = v;
    },

    setLocked(v) {
      //dbg.log("SETLOCKED", self.isLocked, v);
      self.isLocked = v;
    },

    setLoading(v) {
      self.isLoading = v;
    },

    turnToSection() {
      self.item = {
        id: self.item.id,
        x: self.item.x,
        y: self.item.y,
        pos: RACK_SECTION_TYPE3.EMPTY,
      };
      self.rackStore.setItem(self.itemIndex, self.item);
    },

    createMinerStore() {
      return createRackMinerStore(self, mainStore);
    },

    async getUser(): Promise<IColoredUser3 | void> {
      if (!isRackItem3(self.item)) return;
      const handle = rc.createRequestHandle();
      const res = await withLoading(self, getUserById(handle, +self.item.user_id));
      if (!res) return;
      return res.Records[0] as unknown as IColoredUser3;
    },

    setMeta(meta: string) {
      self.item = {...item, meta};
    }
  }
  return makeObservable(self, {
    isLoading: observable,
    isMerging: observable,
    isLocked: observable,
    item: observable,
    itemIndex: observable,
    rackStore: observable,
    setMerging: action,
    setLocked: action,
    setLoading: action,
    turnToSection: action,
    getUser: action,
    createMinerStore: action,
    setMeta: action,
  });
};

const createItemStore = (
  item: ISomeItem, 
  index: number, 
  mainStore: IMainLocationsStore,
  rackStore: IRackStore,
) => 
  createStore(createItemStore_(item, index, mainStore, rackStore));

export default createItemStore;